import React from 'react'

const ApplicantDetails = ({ heading, body }) => {

    function maskMobile(phone) {
        phone = phone ? phone.toString() : "";
        var str = '';
        for (let i = 0; i < phone.length; i++) {
            if (phone.charAt(i) !== "-" && i < 0) {
                str += phone.charAt(i);
            } else if (phone.charAt(i) !== "-" && i > 5) {
                str += phone.charAt(i);
            } else
                str += 'X';
        }
        return str;
    }
    return (
        <>
            <tr>
                <td className='thead text-blue '>{heading}</td>
                {heading === "Mobile Number" ? (
                    <td className='text-blue '>{maskMobile(body)}</td>
                ) : (
                    <td className='text-blue '>{body}</td>
                )}
            </tr>
        </>

    )
}

export default ApplicantDetails
